<template>
<div>
 <SearchForm />
 </div>
</template>

<script>
import SearchForm from './components/SearchForm';

export default {
  name: 'App',
  components: {
    
    SearchForm,
  },
  data () {
    return {

    };
  },
  created () {

  },
  methods: {
   
  },
};
</script>